import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { Listing } from './types/Listing';

interface Query {
  minimumStayMonths?: number;
}

export type ListingBookablePeriodsResponse = Required<
  Pick<Listing, 'bookablePeriods' | 'minimumStayMonths' | 'maxBookableDays'>
> & {
  count: number;
};

export default (makeCall: MakeCall) => (listingId: number, query?: Query) =>
  makeCall<ListingBookablePeriodsResponse>(
    'GET',
    `/api/v2/listing/${listingId}/bookable-periods`,
    {
      query,
    },
  );
